import { IConfigFile, ILiveSources, liveSourcesDefault } from '../utils'

export interface ClientConfig {
  alsoSkipSpecialRef: boolean
  plugins?: {
    terrific?: boolean
    minute_ly?: boolean
  }
  configFile: IConfigFile | undefined
  kaltura_application_name: string
  liveSources: ILiveSources | undefined
  login_page: string
  kalturaPlayerId: string
  newsFlashQuerySource: string | undefined
  baseUrl: string
  googleTagManager: string
  googleAnalytics: string
  disableMetrics: string
  geo_plugin_key: string
  geo_ttl: number
  live_ima: 'enabled' | 'disabled'
  live_mid_rolls: 'enabled' | 'disabled'
  dataQuerySource: string
  kaltura_end_point: string
  kaltura_partner_id: string | number
  bigBrotherRegistration: 'on' | 'off'
  adTargetEnv: string
  adblock_detection: 'enabled' | 'disabled'
}

export const clientConfig: ClientConfig = {
  newsFlashQuerySource: '',
  baseUrl: '',
  googleTagManager: '',
  googleAnalytics: '',
  kalturaPlayerId: '',
  disableMetrics: '',
  live_ima: 'enabled',
  live_mid_rolls: 'enabled',
  dataQuerySource: '',
  geo_plugin_key: '',
  geo_ttl: 60,
  login_page: '',
  kaltura_end_point: 'https://5031.frp1.ott.kaltura.com/api_v3/service/',
  kaltura_partner_id: 5031,
  kaltura_application_name: 'com.kaltura.reshet.web',
  bigBrotherRegistration: 'on',
  liveSources: liveSourcesDefault,
  adTargetEnv: '',
  configFile: {
    video_rail_map_path: null,
    ros_interstitial: 'off',
    recently_aired_json_path: null,
    short_videos_client: '/cdn/short_clips_and_tabs/',
    player: {
      autoplay: {
        desktop: true,
        mobile: false,
        app: false,
      },
    },
  },
  plugins: {
    terrific: false,
    minute_ly: false,
  },
  alsoSkipSpecialRef: false,
  adblock_detection: 'enabled',
}
